import { TrackingConfigDTO } from "../../../shared/src/types/analytics";

export class RemoteConfigLoader {
  public static async fetchConfig(
    endpoint: string,
    communityId: string,
  ): Promise<TrackingConfigDTO | null> {
    try {
      const url = `${endpoint.replace(/\/$/, "")}/v1/tracking/config/${encodeURIComponent(communityId)}`;
      const res = await fetch(url);
      if (!res.ok) return null;
      const data: TrackingConfigDTO = await res.json();
      return data;
    } catch {
      return null;
    }
  }
}
